import { render } from "./ProvinceData.vue?vue&type=template&id=ad6edef2&scoped=true"
import script from "./ProvinceData.vue?vue&type=script&lang=js"
export * from "./ProvinceData.vue?vue&type=script&lang=js"

import "./ProvinceData.vue?vue&type=style&index=0&id=ad6edef2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad6edef2"]])

export default __exports__